export { CarouselIcon } from './carousel-icon'
